import React from "react";
import { useState } from "react";

import "../css/general.css";
import "../css/logo-btn.css";
import "../css/my-name.css";
import "../css/nav.css";
import "../css/queries.css";
import "../css/style.css";

import myLogo from "../img/my-logo-2.png";

export default function NavBar() {
  const [isNavExpanded, setIsNavExpanded] = useState(false);

  const handleCloseNavExpanded = () => {
    setTimeout(() => {
      setIsNavExpanded(!isNavExpanded);
    }, 100);
  };

  return (
    <>
      <header className={isNavExpanded ? "header nav-open" : "header"}>
        <a href="/#" className="btn btn-two">
          <img className="logo-img" src={myLogo} alt="Jayant Arora logo" />
        </a>

        <nav className="main-nav">
          <ul className="menu-links">
            <li>
              <a href="/#projects" onClick={() => handleCloseNavExpanded()}>
                Projects
              </a>
            </li>
            <li>
              <a href="/#next" onClick={() => handleCloseNavExpanded()}>
                Next Apps
              </a>

              {/* <a onClick={() => handleCloseNavExpanded()} href="/resume">
                Resume
              </a> */}
            </li>
            <li>
              <a href="/#dummy" onClick={() => handleCloseNavExpanded()}>
                Dummy Apps
              </a>
            </li>
            <li>
              <a href="/#react" onClick={() => handleCloseNavExpanded()}>
                React Apps
              </a>
            </li>
            <li>
              <a href="/#js" onClick={() => handleCloseNavExpanded()}>
                JS Apps
              </a>
            </li>

            <li className="main-nav-contact">
              <a
                className="contact-btn contact-link"
                href="#contact"
                onClick={() => handleCloseNavExpanded()}
              >
                Contact me
              </a>
            </li>
          </ul>
        </nav>

        <button
          className="btn-mobile-nav"
          href="/"
          onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}
        >
          <ion-icon
            className="icon-mobile-nav"
            name="menu-outline"
            style={{ display: isNavExpanded ? "none" : "inline-block" }}
          ></ion-icon>
          <ion-icon
            className="icon-mobile-nav"
            name="close-outline"
            style={{ display: !isNavExpanded ? "none" : "inline-block" }}
          ></ion-icon>
        </button>
      </header>
    </>
  );
}
